import type { AddonGroup } from '~/models';

import { useNuxtApp } from '#app';
import { useAddonGroup } from '~/composables/useAddonGroup';
import type { Filter } from '~/services/addon';

const useAddonStore = defineStore('customer-addon', () => {
  const { $http } = useNuxtApp();

  const list = async (filter?: Filter): Promise<AddonGroup[]> => {
    const response = (await $http.addon.list(filter)) ?? [];
    useAddonGroup(response).normalize();

    return response;
  };

  return {
    list
  };
});

export { useAddonStore };
